// TODO: Set line-height to 1 so that height is the same as passed size (className property is not available)

import React from 'react';
import { Emoji as EmojiMartEmoji, EmojiProps as TEmojiMartEmojiProps, EmojiData as TEmojiData } from 'emoji-mart';
import type allEmojiData from 'emoji-mart/data/all.json';
import type { TExample } from '@atlas/uicorn/preview/modules';

const Emoji = React.memo(function Emoji(props: TEmojiProps): React.ReactElement {
    return <EmojiMartEmoji {...props} size={props.size ?? 22} />;
});

export default Emoji;

// #region Types

export type TEmojiId = keyof typeof allEmojiData['emojis'] | keyof typeof allEmojiData['aliases'];

export type TEmojiProps = Omit<TEmojiMartEmojiProps, 'size' | 'emoji'> &
    Partial<Pick<TEmojiMartEmojiProps, 'size'>> & {
        emoji: TEmojiData | TEmojiId;
    };

// #endregion

// #region Examples

export const Example: TExample = {
    render(props) {
        return <Emoji emoji={props.emoji ?? 'smile'} size={props.size} />;
    },
    controls: {
        emoji: {
            type: ['hourglass_flowing_sand', 'speech_balloon', 'smile', 'heart', 'rocket', 'fire'],
            required: true,
        },
        size: {
            type: 'number',
            min: 1,
            max: 100,
            initial: 20,
        },
    },
};

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect } = import.meta.vitest;
    describe('Emoji', async () => {
        const testModule = '@test';
        const { render } = await import(/* @vite-ignore */ testModule);

        test('matches snapshot', () => {
            const result = render(<Example.render emoji="speech_balloon" />);
            expect(result.container).toMatchSnapshot();
        });
    });
}

// #endregion
